import React from "react";
import { commitMutation } from "react-relay";

import { environment } from "~/models";
import { Button } from "~/ui";
import { Input, Modal } from "~/ui/legacyFellowIndex";
import toast from "~/ui/toast";

import { updateMutation } from "./NoteCard";

import type { NoteCardUpdateMutation as UpdateMutationType } from "~/__generated__/NoteCardUpdateMutation.graphql";

import styles from "./css/RenameNoteModal.module.css";

interface State {
	title: string;
}

interface Props {
	id: string;
	initialTitle: string;
	onClose: () => void;
}

class RenameNoteModal extends React.PureComponent<Props, State> {
	constructor(props: Props) {
		super(props);

		this.state = { title: props.initialTitle };
	}

	onTitleChange = (event: React.ChangeEvent<HTMLInputElement>) => this.setState({ title: event.target.value });

	onSave = () => {
		commitMutation<UpdateMutationType>(environment, {
			mutation: updateMutation,
			variables: {
				input: {
					noteId: this.props.id,
					updates: { title: this.state.title },
				},
			},
			onCompleted: ({ updateNote }, errors) => {
				if (errors?.length || !updateNote?.note || !updateNote.ok) {
					toast.error("Unable to update note title");
				} else {
					toast.success("Note title updated");
					this.props.onClose();
				}
			},
		});
	};

	onKeyPress = (event: React.KeyboardEvent<HTMLInputElement>) => {
		if (event.key == "Enter") this.onSave();
	};

	render() {
		const { onClose } = this.props;

		return (
			<Modal onClose={onClose} width="27.5rem">
				<Modal.Header onClose={onClose} noBottomBorder>
					<Modal.Title>Rename note</Modal.Title>
				</Modal.Header>
				<Modal.Body noPadding>
					<Input
						className={styles.inputField}
						value={this.state.title}
						onChange={this.onTitleChange}
						placeholder="Untitled note"
						maxLength={255}
						onKeyPress={this.onKeyPress}
						autoFocus
						name="note_title"
					/>
				</Modal.Body>
				<Modal.Footer noTopBorder>
					<Button size="normal" onClick={onClose}>
						Cancel
					</Button>
					<Button size="normal" variant="primary" onClick={this.onSave} data-test-id="yes-button">
						Save
					</Button>
				</Modal.Footer>
			</Modal>
		);
	}
}

export default RenameNoteModal;
